export const HOURS = {
    PM: ["12:00", "02:00", "02:30", "03:00", "04:00", "04:30", "05:30", "06:00", "06:30"],
    AM: ["07:00", "07:30", "08:00", "08:30", "09:00", "09:30", "10:30", "11:00", "11:30"]
}